import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { configureApiFetch } from './utils/api';

configureApiFetch();

// Suppress noisy extension errors in development (e.g., React/Redux DevTools)
if (process.env.NODE_ENV === 'development') {
  window.addEventListener('error', (e) => {
    try {
      const src = String(e?.filename ?? '');
      const msg = String(e?.message ?? '');
      if (src.startsWith('chrome-extension://') || msg.includes('disconnected port object')) {
        e.preventDefault();
      }
    } catch {}
  });
  window.addEventListener('unhandledrejection', (e) => {
    try {
      const msg = String(e?.reason?.message ?? e?.reason ?? '');
      if (msg.includes('disconnected port object')) {
        e.preventDefault();
      }
    } catch {}
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
